import { fetchAPI } from "./apiCore";

export const fetchAdminSampleTypes = async () => {
  try {
    return await fetchAPI("biobank/sample-types", "GET");
  } catch (error) {
    console.error("Error fetching sample types:", error);
    return [];
  }
};

export const fetchAdminSampleTypeByLetter = async (sampleLetter) => {
  try {
    return await fetchAPI(
      `biobank/sample-types/${encodeURIComponent(sampleLetter)}`,
      "GET"
    );
  } catch (error) {
    console.error(`Error fetching sample type ${sampleLetter}:`, error);
    return null;
  }
};

export const createAdminSampleType = async (payload) => {
  try {
    return await fetchAPI("biobank/sample-types", "POST", {}, payload);
  } catch (error) {
    console.error("Error creating sample type:", error);
    throw error;
  }
};

export const updateAdminSampleType = async (sampleLetter, payload) => {
  try {
    return await fetchAPI(
      `biobank/sample-types/${encodeURIComponent(sampleLetter)}`,
      "PUT",
      {},
      payload
    );
  } catch (error) {
    console.error("Error updating sample type:", error);
    throw error;
  }
};

export const fetchAdminKitTypes = async () => {
  try {
    return await fetchAPI("biobank/kit-types", "GET");
  } catch (error) {
    console.error("Error fetching kit types:", error);
    return [];
  }
};

export const createAdminKitType = async (payload) => {
  try {
    return await fetchAPI("biobank/kit-types", "POST", {}, payload);
  } catch (error) {
    console.error("Error creating kit type:", error);
    throw error;
  }
};

export const updateAdminKitType = async (kitType, payload) => {
  try {
    return await fetchAPI(
      `biobank/kit-types/${encodeURIComponent(kitType)}`,
      "PUT",
      {},
      payload
    );
  } catch (error) {
    console.error("Error updating kit type:", error);
    throw error;
  }
};
export const fetchAdminFollowUpTypes = async () => {
  try {
    return await fetchAPI("biobank/follow-up-types", "GET");
  } catch (error) {
    console.error("Error fetching follow-up types:", error);
    return [];
  }
};

export const createAdminFollowUpType = async (payload) => {
  try {
    return await fetchAPI("biobank/follow-up-types", "POST", {}, payload);
  } catch (error) {
    console.error("Error creating follow-up type:", error);
    throw error;
  }
};

export const updateAdminFollowUpType = async (followUpType, payload) => {
  try {
    return await fetchAPI(
      `biobank/follow-up-types/${encodeURIComponent(followUpType)}`,
      "PUT",
      {},
      payload
    );
  } catch (error) {
    console.error("Error updating follow-up type:", error);
    throw error;
  }
};
